import "./partners.css";
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { sliderResponsive } from "../../shared/sliderConfig";

import p1 from "../../assets/partners/Partner1.jpg";
import p2 from "../../assets/partners/Partner2.jpg";
import p3 from "../../assets/partners/Partner3.jpg";
import p4 from "../../assets/partners/Partner4.jpg";
import p5 from "../../assets/partners/Partner5.jpg";
import p6 from "../../assets/partners/Partner6.jpg";
import p7 from "../../assets/partners/Partner7.jpg";
import p8 from "../../assets/partners/Partner8.jpg";
import p9 from "../../assets/partners/Partner9.jpg";
import p10 from "../../assets/partners/Partner10.jpg";
import p11 from "../../assets/partners/Partner11.jpg";
import p12 from "../../assets/partners/Partner12.jpg";
import p13 from "../../assets/partners/Partner13.jpg";
import p14 from "../../assets/partners/Partner14.jpg";
import p15 from "../../assets/partners/Partner15.jpg";
import p16 from "../../assets/partners/Partner16.jpg";
import p17 from "../../assets/partners/Partner17.jpg";
import p18 from "../../assets/partners/Partner18.jpg";
import p19 from "../../assets/partners/Partner19.jpg";
import p20 from "../../assets/partners/Partner20.jpg";
import p21 from "../../assets/partners/Partner21.jpg";
import p22 from "../../assets/partners/Partner22.jpg";
import p23 from "../../assets/partners/Partner23.jpg";
import p24 from "../../assets/partners/Partner24.jpg";
import p25 from "../../assets/partners/Partner25.jpg";

const logos = [
  p1, p2, p3, p4, p5, p6, p7,
  p8, p9, p10, p11, p12, p13, p14,
  p15, p16, p17, p18, p19, p20, p21,
  p22, p23, p24, p25,
];

const chunkArrayCustom = (arr, sizes) => {
  const result = [];
  let index = 0;
  for (const size of sizes) {
    if (index >= arr.length) break;
    result.push(arr.slice(index, index + size));
    index += size;
  }
  return result;
};

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 2,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2500,
  responsive: sliderResponsive,
};

const Partners = () => {
  const isMobile = useMediaQuery({ maxWidth: 1250 });
  const rows = chunkArrayCustom(logos, [7, 7, 6, 5]);

  return (
    <div className="partners">
      <p className="partners-title">Somos aliados de las mejores marcas</p>
      {isMobile ? (
        <Slider {...sliderSettings}>
          {logos.map((src, i) => (
            <div key={i} className="partner-card">
              <img src={src} alt="" />
            </div>
          ))}
        </Slider>
      ) : (
        <div className="partners-grid">
          {rows.map((row, rowIdx) => (
            <div
              key={rowIdx}
              className={`partners-row${rowIdx === rows.length - 1 ? " partners-row--last" : ""}`}
            >
              {row.map((src, i) => (
                <div key={i} className="partner-card">
                  <img src={src} alt="" />
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Partners;
